export async function network(endpoint, init) {
    const _init = init || {};
    const root = init?.admin ? "/api/v1/admin" : "/api/v1/front";
    let url = `${root}${endpoint}`;
    if (init?.json) {
        _init.body = JSON.stringify(init.json);
        _init.headers = {
            ..._init.headers,
            "Content-Type": "application/json",
        };
    }
    if (init?.query) {
        url += `?${new URLSearchParams(init.query).toString()}`;
    }
    const response = await fetch(url, _init);
    if (!response.ok) {
        throw new Error(response.statusText);
    }
    return await response.json();
}
